import { IconErrorOutline, Text } from '@bbl-digital/snorre'
import { useTheme } from '@emotion/react'
import { FC } from 'react'
import { Wrapper } from './styles'

interface IProps {
  text: string
  withIcon?: boolean
  marginTop?: number
}

const ErrorText: FC<IProps> = ({ text, withIcon = true, marginTop }) => {
  const theme = useTheme()

  return withIcon ? (
    <Wrapper marginTop={marginTop}>
      <IconErrorOutline size="16px" color={theme.alert} />
      <Text semibold color={theme.alert} size="14px">
        {text}
      </Text>
    </Wrapper>
  ) : (
    <Text semibold color={theme.alert} size="14px">
      {text}
    </Text>
  )
}

export default ErrorText
